import React from 'react'
import { Pane, Text } from 'evergreen-ui'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_12 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { statusContent } = useStatusContent(row.ROB_ID, "12")
  const title = statusContent.titleText || 'ไม่ผ่านเกณฑ์การสมัคร'
  const body = statusContent.bodyText || 'ติดต่องานรับสมัครนักศึกษา โทร 055-706-547'

  return (
    <Pane
      fontWeight={700}
      backgroundColor="#ff0000"
      height="100%"
      paddingY={4}
      paddingX={5}
      fontSize={16}
      fontFamily=""
      display="flex" alignItems="center" justifyContent="center" flexDirection="column"
    >
      <Text
        color="#ffffff"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
      >
        {title}
      </Text>
      {body ? (
        <Text
          color="#ffffff"
          height="100%"
          paddingY={4}
          paddingX={5}
          fontSize={16}
          fontFamily=""
        >
          {body}
        </Text>
      ) : null}
    </Pane>
  )
}

export default StatusRegister_12
